export const HOME_EVENT_PAGE_SIZE = 24;

export type HomeEventFilter = 'upcoming' | 'past';

export type EventPageCursor = Readonly<{
  id: string;
  startsAt: string;
}>;

export type EventPage<T> = Readonly<{
  items: T[];
  nextCursor: EventPageCursor | null;
}>;

type HomeFeedEvent = Readonly<{ ends_at?: string | null; id: string; starts_at: string }>;

export function eventBelongsToHomeFilter(
  event: HomeFeedEvent,
  filter: HomeEventFilter,
  now: Date
): boolean {
  const end = event.ends_at ? new Date(event.ends_at) : new Date(event.starts_at);
  return filter === 'upcoming' ? end > now : end <= now;
}

export function createBoundedEventPage<T extends HomeFeedEvent>(
  events: readonly T[],
  limit = HOME_EVENT_PAGE_SIZE
): EventPage<T> {
  const items = events.slice(0, limit);
  const last = items.at(-1);
  return {
    items,
    nextCursor: events.length > limit && last ? { id: last.id, startsAt: last.starts_at } : null,
  };
}

export function registeredFutureEvents<T extends HomeFeedEvent>(
  events: readonly T[],
  registeredEventIds: ReadonlySet<string>,
  now: Date
): T[] {
  return events
    .filter((event) => registeredEventIds.has(event.id) && new Date(event.starts_at) > now)
    .sort((left, right) =>
      new Date(left.starts_at).getTime() === new Date(right.starts_at).getTime()
        ? left.id.localeCompare(right.id)
        : new Date(left.starts_at).getTime() - new Date(right.starts_at).getTime()
    );
}
